// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  initializeAuth,
  signInAnonymously,
  browserLocalPersistence,
  inMemoryPersistence,
} from "firebase/auth";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { initializeFirestore, collection, addDoc } from "firebase/firestore";
import { isWebKitEngine } from "./isWebKitEngine";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = initializeAuth(app, {
  persistence: [browserLocalPersistence, inMemoryPersistence],
});
const storage = getStorage(app);
// On WebKit, long polling instead of the default fetch stream. WebKit >= 26.4
// (Safari 26.4+ and every iOS browser) strands the tail of a streaming fetch()
// body until the server writes again (WebKit bug 322545). Firestore's listen
// channel is such a stream and goes quiet after answering, so reads and
// listener updates waited for the ~30 s keep-alive — BUG-0011's splash,
// BUG-0014's avatars list, and the `uploaded: true` Submit waits for. A
// long-polled response ENDS after each message, and WebKit flushes a body on
// completion, so there is nothing left to withhold.
// Every other engine keeps exactly getFirestore's defaults ({}): long polling
// made Chromium reads ~0.1–0.6 s slower for no benefit. See TRAPS.md.
// Never add experimentalAutoDetectLongPolling beside it: the SDK throws.
const db = initializeFirestore(
  app,
  isWebKitEngine() ? { experimentalForceLongPolling: true } : {},
);

export {
  auth,
  signInAnonymously,
  storage,
  db,
  ref,
  uploadBytes,
  collection,
  addDoc,
};
